/**
 * Capitalizes the first letter of a string and converts the rest to lowercase.
 * @param {string} s - String to capitalize
 * @example
 * capitalize('hello world') // returns 'Hello world'
 * capitalize('hELLO wORLD') // returns 'Hello world'
 * @returns {string} - The capitalized string
 */
export const capitalize = (s: string) =>
  s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()

/**
 * Helper function for decoding URL parameters
 * This function decodes a given string value from a URL-encoded format.
 * @param {string} value - The URL-encoded string to decode.
 * @returns {string} - The decoded string value.
 */
export const decodeTagValue = (value: string): string => {
  try {
    // First replace all + with %20, then decode
    return decodeURIComponent(value.replace(/\+/g, '%20'))
  } catch (_) {
    // If decoding fails, return the original value
    return value
  }
}
